<template>
  <div class="config">
    <Form ref="configData"
          :model="config"
          :rules="configValidate"
          action="javascript:void(0)"
          :label-width="80">
      <FormItem label="现金红包"
                prop="cash_totals_red">
        <Input v-model="config.cash_totals_red"
               placeholder
               style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">平台一天最多放多少个</label>
      </FormItem>
      <FormItem label="现金红包"
                prop="cash_min_red">
        <Input v-model="config.cash_min_red"
               style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">红包最小多少，单位 元</label>
      </FormItem>
      <FormItem label="现金红包"
                prop="cash_max_red">
        <Input v-model="config.cash_max_red"
               style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">红包最大多少，单位 元</label>
      </FormItem>
      <FormItem label="领取次数"
                prop="app_one_red">
        <Input v-model="config.app_one_red"
               style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">一个人一天可以领多少次</label>
      </FormItem>
      <FormItem label="赠送数量"
                prop="send_num">
        <Input v-model="config.send_num"
               style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">每天赠送数量</label>
      </FormItem>
      <!-- <FormItem label="APP代金券" prop="app_totals_red">
        <Input v-model="config.app_totals_red" style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">平台一天最多放多少个</label>
      </FormItem>
      
      <FormItem label="距离" prop="distance">
        <Input v-model="config.distance" style="width: 200px"></Input>
        <label style="margin-left: 20px;color: #999">几米内可以领</label>
      </FormItem> -->
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('configData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>


<script>
export default {
  name: "config",
  data () {
    return {
      config: {
        cash_totals_red: "",
        cash_min_red: "",
        cash_max_red: "",
        app_totals_red: "",
        app_one_red: "",
        distance: ""
      },
      configValidate: {
        // cash_totals_red: [
        //     { required: true, message: '平台一天最多放多少个', trigger: 'blur' }
        // ],
        // cash_min_red: [
        //     { required: true, message: '红包最小多少，单位 元', trigger: 'blur' }
        // ],
        // cash_max_red: [
        //     { required: true, message: '红包最大多少，单位 元', trigger: 'blur' }
        // ],
        // app_totals_red: [
        //     { required: true, message: '平台一天最多放多少个', trigger: 'blur' }
        // ],
        // app_one_red: [
        //     { required: true, message: '一个人一天可以领多少次', trigger: 'blur' }
        // ],
        // distance: [
        //     { required: true, message: '几米内可以领', trigger: 'blur' }
        // ]
      }
    };
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$api.noteConfig.edit(this.config).then(res => {
            if (res.code == 200) {
              this.$Message.success("修改成功...");
            }
          });
        }
      });
    },
    getConfig: function () {
      this.$api.noteConfig.detail().then(res => {
        this.config = res.result;
        console.log(this.config);
      });
    }
  }
};
</script>